/** Company-profile tags: localized translation first, then exhibitor/sponsor tags. */
export function pickCompanyTagNames(
  translationTags?: string[] | null,
  companyTags?: string[] | null
): string[] {
  const source =
    translationTags && translationTags.length ? translationTags : companyTags;
  return (source ?? []).map((tag) => String(tag).trim()).filter(Boolean);
}
